import { render } from "./Busca.vue?vue&type=template&id=a87a3ea6"
import script from "./Busca.vue?vue&type=script&lang=js"
export * from "./Busca.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__